import { useState } from "react";
import { ReportAPI } from "../../../../axios/api";
import { useAbortedEffect } from "../../../../components/hooks";
import moment from "moment";

import {
  useSearchFilter,
  ModuleSearchFilterWrap,
} from "../../../../components/searchFilter";
import ModuleSectionBlock from "../../../../components/sectionBlock";
import ModuleBlockLoading from "../../../../components/loading";
import { ModuleChartLine } from "../../../../components/chart";
import { floatAdd } from "../../../../service/common";

export default function ModuleCustomChartDailyStatistic() {
  const [reload, setReload] = useState(false);
  const { filterData, searchData, setSearchData, changeFilter } =
    useSearchFilter({
      defaultFilter: {
        period: 1,
        startDate: moment().startOf("month").format("YYYY-MM-DD"),
        endDate: moment().endOf("month").format("YYYY-MM-DD"),
      },
      searchKey: ["usageStatistic"],
      reloadAction: () => setReload(true),
    });
  const filterColumns = [
    {
      ui: "calendar",
      uiClassName: "w-9rem",
      label: "起始",
      params: {
        name: "startDate",
        // maxKey: "endDate",
        dateEffectKey: "endDate",
        dateDirection: "start",
        dateEffectNumber: null,
        dateEffectUnit: "months",
      },
    },
    {
      ui: "calendar",
      uiClassName: "w-9rem",
      label: "結束",
      params: {
        name: "endDate",
        // minKey: "startDate",
        dateEffectKey: "startDate",
        dateDirection: "end",
        dateEffectNumber: null,
        dateEffectUnit: "months",
      },
    },
  ];
  const [apiData, setApiData] = useState({
    format: { keys: [], data: [] },
  });

  useAbortedEffect(
    (signal) => {
      if (!reload) return;

      const periodMap = {
        1: "day",
        2: "month",
        3: "year",
      };
      const params = {
        startDate: searchData.startDate,
        endDate: searchData.endDate,
        period: periodMap[searchData.period] ?? "day",
        groupBuildingFloorRoom: [],
      };

      ReportAPI.getEnergyTrend({
        options: { signal },
        data: params,
      }).then((result) => {
        let { Response, data } = result;

        if (Response === 1) {
          formatHandler({ data });
          setReload(false);
        }
      });
    },
    [reload],
  );

  const formatHandler = ({ data }) => {
    const totalEnergy = data.items.reduce(
      (total, item) => floatAdd(total, Number(item.totalEnergy) || 0),
      0,
    );
    const formatData = data.items.map((item) => ({
      date: item.date?.replaceAll("-", "/") ?? "",
      value: item.totalEnergy,
    }));

    setApiData({
      format: {
        isTenThousandUnit: totalEnergy > 30000,
        keys: [{ key: "value", name: "實際用量" }],
        data: formatData,
      },
    });
  };

  return (
    <ModuleSectionBlock
      targetId="dailyStatistic"
      title="日用量"
      isExport={true}
      exportOptions={[
        {
          isList: true,
          listOptions: [
            {
              listColumns: [
                {
                  field: "date",
                  header: "日期",
                  exportOptions: {
                    width: 15,
                  },
                },
                ...apiData.format.keys.map((item) => ({
                  field: item.key,
                  header: item.key,
                  exportOptions: {
                    width: 15,
                  },
                })),
              ],
              listData: apiData.format.data,
              listPos: { x: 0, y: 1 },
            },
          ],
          isImg: true,
          imgOptions: [
            {
              imgId: "dailyStatistic",
              imgPos: { x: 2 + apiData.format.keys.length, y: 1 },
            },
          ],
        },
      ]}
      overlaySetting={[
        {
          icon: "pi pi-filter",
          template: (
            <ModuleSearchFilterWrap
              className="w-auto text-white"
              columns={filterColumns}
              filterData={filterData}
              setSearchData={setSearchData}
              changeFilter={changeFilter}
            />
          ),
        },
      ]}
      bodyTemplate={
        <>
          {reload && <ModuleBlockLoading />}

          <ModuleChartLine
            className="w-full h-15rem my-2"
            data={apiData.format}
            options={{
              dataKey: "date",
              yAxisOptions: {
                label: {
                  left: {
                    value: `${apiData.format.isTenThousandUnit ? "萬" : ""}kWh`,
                    position: "insideTopLeft",
                    dx: apiData.format.isTenThousandUnit ? 30 : 40,
                    dy: -30,
                  },
                },
              },
            }}
          />
        </>
      }
    />
  );
}
